module.exports = __webpack_public_path__ + "media/pourquoi_donner/mode_circulaire-44dd48df.gif";